import { Injectable } from '@angular/core';
import { Nav } from '../models/navigation';
import { IamService } from './iam.service';

@Injectable()
export class NavService {
  dashboard: Nav;
  assistance: Nav;
  medical: Nav;
  insurance: Nav;
  members: Nav;
  dental: Nav;
  teledoctor: Nav;
  other: Nav;
  buca: Nav;
  sds: Nav;
  titleCase: string;
  iAm = null;
  generalConfigurations: Nav;

  constructor(public iam: IamService) {
    this.iAm = this.iam.isRole;
    // Dashboard
    this.dashboard = new Nav();
    this.dashboard.title = 'Dashboard';
    this.dashboard.roles = ['assistance_salecapture', 'assistance_admin'];
    this.dashboard.options = {
      assistance_case: {
        title: 'Assistance Cases',
        url: '/admin/assistance/cases/dashboard',
        icon: 'fa fa-bar-chart',
        roles: [
          'assistance_admin',
          'supervisor',
          'networkleader',
          'operator',
          'cabin_agent',
          'quality',
          'assistance_ws_sale',
          'assistance_ws_case',
          'assistance_web_service',
          'assistance_dispatcher',
          'assistance_dispatcher_vial',
          'assistance_dispatcher_medical',
          'teledoctor_agent'
        ],
      },
      assistance_sales: {
        title: 'Assistance Sales',
        url: '/admin/assistance/sales',
        icon: 'fa fa-bar-chart',
        roles: ['assistance_admin', 'assistance_salesman', 'admin'],
      },
      assistance_survey: {
        title: 'Quality Survey',
        url: '/admin/assistance/cases/survey/dashboard',
        icon: 'fa fa-bar-chart',
        roles: [
          'assistance_admin',
          'quality',
          'supervisor',
          'operator',
          'cabin_agent',
          'teledoctor_agent'
        ],
      },
      asistemeLogs: {
        title: 'Asisteme Logs',
        url: '/admin/asisteme-provider/logs',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/teledoctor_log.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/teledoctor_log_over.svg",
        roles: ['networkleader', 'assistance_dispatcher']
      },
      assistance_reprocess: {
        title: 'Assistance Reprocess',
        url: '/admin/assistance/cases/reprocesses/dashboard',
        icon: 'fa fa-bar-chart',
        roles: [
          'assistance_admin',
          'quality',
          'supervisor',
          'networkleader',
          'operator',
          'cabin_agent',
          'teledoctor_agent'
        ],
      },
    };

    // Assistance
    this.assistance = new Nav();
    this.assistance.title = 'Assistances';
    this.assistance.roles = [
      'product supervisor',
      'supervisor',
      'networkleader',
      'operator',
      'cabin_agent',
      'quality',
      'assistance_admin',
      'assistance_salesman',
      'assistance_salecapture_supervisor',
      'assistance_salescapture_cemex_supervisor',
      'assistance_dispatcher',
      'assistance_salescapture_detektor_supervisor',
      'assistance_dispatcher_vial',
      'assistance_dispatcher_medical',
      'assistance_salescapture_detektor',
      'assistance_salecapture',
      'assistance_salescapture_cemex',
      'assistance_teledoctor_sale',
      'assistance_salescapture_mr_barber',
      'assistance_salescapture_mr_barber_supervisor',
      'assistance_salescapture_credix',
      'assistance_salescapture_credix_supervisor',
      'assistance_salescapture_coopenae',
      'assistance_salescapture_coopenae_supervisor',
      'assistance_salescapture_trt',
      'assistance_salescapture_trt_supervisor',
      'assistance_salescapture_instacredit',
      'assistance_salescapture_instacredit_supervisor',
      'assistance_salescapture_suzuki',
      'assistance_salescapture_suzuki_supervisor',
      'assistance_provider',
      'assistance_salescapture_impressa_repuestos_supervisor',
      'assistance_salescapture_impressa_repuestos',
      'assistance_bill_finances',
      'assistance_salescapture_promerica',
      'assistance_salescapture_promerica_supervisor',
      'operation_sac',
      'teledoctor_agent',
      'assistance_teledoctor_sale',
      'teledoctor_doctor_inspector'

    ];
    this.assistance.options = {
      members: {
        title: 'Members',
        url: '/admin/members',
        icon: 'fa fa-fw fa-user-circle-o',
        roles: ['assistance_admin', 'insurance_admin', 'medical_admin', 'assistance_teledoctor_sale'],
      },
      policies: {
        title: 'Assistances',
        url: '/admin/assistance/sales',
        icon: 'fa fa-fw fa-file-text-o',
        roles: [
          'supervisor',
          'assistance_admin',
          'assistance_salesman',
          'assistance_teledoctor_sale',
        ],
      },
      tickets: {
        title: 'All Assistance Cases (v1)',
        url: '/admin/assistance-v1/cases',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/cases2.svg',
        roles: [
          'user_access_v1'
        ],
      },
      tickets_v2: {
        title: 'All Assistance Cases',
        url: '/admin/assistance/cases/search',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/cases2.svg',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/default/todas-gestiones.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/hover/todas-gestiones-HOVER%201.svg",
        roles: [
          'cases_v2',
          'supervisor',
          'operator',
          'operator_cas',
          'cabin_agent',
          'quality',
          'networkleader',
          'assistance_admin',
          'assistance_salesman',
          'assistance_dispatcher',
          'assistance_dispatcher_vial',
          'assistance_dispatcher_medical',
          'assistance_bill_finances',
          'teledoctor_doctor',
          'cabin_read_only',
          'admin_networkleader',
          'accountant',
          'treasurer',
          'operator_reimbursement',
          'authorizer_reimbursement',
          'treasure_reimbursement',
        ],
      },
      my_tickets_v2: {
        title: 'My cases',
        url: '/admin/assistance/cases/my-cases',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_cases.svg',
        roles: [
          'cases_v2',
          'supervisor',
          'operator',
          'cabin_agent',
          'assistance_admin',
          'assistance_salesman',
          'assistance_dispatcher',
          'assistance_dispatcher_vial',
          'assistance_dispatcher_medical',
          'teledoctor_doctor',
          'admin_networkleader',
          'accountant',
          'treasurer'
        ],
      },
      chat_inbox_v2: {
        title: 'Chat inbox of assistance',
        url: '/admin/assistance/cases/chat-inbox',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/chat-asistencas.svg',
        roles: [
          'supervisor',
          'assistance_dispatcher',
          'assistance_dispatcher_vial',
          'assistance_dispatcher_medical',
          'assistance_dispatcher_vip',
          'admin',
          'operator',
          'cabin_agent',
          'assistance_admin',
          'assistance_chat_operador',
        ],
      },
      create_tickets_v2: {
        title: 'Create Assistance Case',
        url: '/admin/assistance/cases/create',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_cases.svg',
        roles: [
          'cases_v2',
          'supervisor',
          'operator',
          'cabin_agent',
          'assistance_admin',
          'assistance_salesman',
          'teledoctor_doctor',
        ],
      },
      Medicaltickets: {
        title: 'All Medical Assistance Cases',
        url: '/admin/medical/cases',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/cases2.svg',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/default/Medicas-todas-gestiones.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/hover/Medicas-todas-gestiones-HOVER%201.svg",
        roles: [
          'supervisor',
          'operator',
          'operator_cas',
          'cabin_agent',
          'quality',
          'networkleader',
          'assistance_admin',
          'assistance_salesman',
          'assistance_dispatcher',
          'assistance_dispatcher_vial',
          'assistance_dispatcher_medical',
          'assistance_bill_finances',
          'teledoctor_doctor',
          'medical_supervisor',
          'medical_admin'
        ],
      },
      create_tickets: {
        title: 'Create Assistance Case (v1)',
        url: '/admin/assistance-v1/cases/create',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_cases.svg',
        roles: [
          'user_access_v1'
        ],
      },
      create_medical_tickets: {
        title: 'Create Medical Assistance Case',
        url: '/admin/medical/cases',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_cases.svg',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/default/Medicas-crear-gestion.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/hover/Medicas-crear-gestion-HOVER%201.svg",
        roles: [
          'supervisor',
          'medical_operator'
        ],
      },
      following_dashboard: {
        title: 'Following Dashboard',
        url: '/admin/assistance/cases/following',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/default/seguimiento-casos-DASHBOARD.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/hover/seguimiento-casos-DASHBOARD-HOVER%201.svg",
        roles: [
          'admin',
          'supervisor',
          'quality',
          'assistance_admin',
          'teamleader',
          'networkleader',
          'operator',
          'assistance_dispatcher',
          'assistance_dispatcher_vial',
          'assistance_dispatcher_medical',
          'cabin_read_only'
        ],
      },
      my_tickets: {
        title: 'My cases (v1)',
        url: '/admin/assistance-v1/cases/my-cases',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_cases.svg',
        roles: [
          'user_access_v1'
        ],
      },
      my_medical_tickets: {
        title: 'My Medical cases',
        url: '/admin/medical/cases/my-cases',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_cases.svg',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/default/Medicas-mis-gestiones.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/hover/Medicas-mis-gestiones-HOVER%201.svg",
        roles: ['admin', 'medical_admin', 'medical_operator', 'medical_supervisor', 'medical_doctor']
      },
      online_users: {
        title: 'Users online',
        url: '/admin/assistance/usersavailable',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/Icon_online_users.svg',
        roles: ['supervisor', 'assistance_admin', 'teledoctor_doctor_inspector'],
      },
      assistance_cases_assignment: {
        title: 'Reassignment of case',
        url: '/admin/assistance/case/assignment',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_reasigment_cases.svg',
        roles: ['supervisor', 'assistance_admin'],
      },
      claims: {
        title: 'Claims',
        url: '/admin/assistance/cases/claims',
        icon: 'fa fa-fw fa-user-times',
        roles: [
          'supervisor',
          'assistance_admin',
          'operator',
          'cabin_agent',
          'networkleader',
          'teledoctor_agent'
        ],
      },
      reprocesses: {
        title: 'Reprocesses',
        url: '/admin/assistance/reprocesses',
        icon: 'fa fa-fw fa-user',
        roles: ['assistance_admin', 'supervisor', 'quality'],
      },
      ambulance_service: {
        title: 'Ambulance',
        url: '/admin/assistance/cases/ambulance-service',
        icon: 'fa fa-fw fa-ambulance',
        roles: [
          'assistance_admin',
          'assistance_salesman',
          'supervisor',
          'assistance_teledoctor_sale',
          'operator',
          'cabin_agent',
          'assistance_dispatcher',
          'assistance_dispatcher_vial',
          'assistance_dispatcher_medical',
          'assistance_teledoctor_sale',
          'teledoctor_agent'
        ],
      },
      products: {
        title: 'Products',
        url: '/admin/assistance/products',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_products.svg',
        roles: ['product supervisor', 'assistance_admin'],
      },
      medicalProducts: {
        title: 'Medical Products',
        url: '/admin/medical/products',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/default/Medicas-productos.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/hover/Medicas-productos-HOVER%201.svg",
        roles: ['medical_admin', 'teledoctor_admin']
      },
      services: {
        title: 'Services',
        url: '/admin/assistance/services',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_services.svg',
        roles: ['product supervisor', 'assistance_admin', 'services_keywords_only_admin'],
      },
      services_sap: {
        title: 'Services SAP',
        url: '/admin/assistance/services/sap',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_sales.svg',
        roles: ['product supervisor', 'assistance_admin'],
      },
      cover_letter: {
        title: 'Cover Letter',
        url: '/admin/assistance-cover-letter/letter',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_cover_letter.svg',
        roles: ['assistance_admin', 'assistance_salesman', 'assistance_chubb'],
      },
      cover_letter_form: {
        title: 'Create a Cover Letter',
        url: '/admin/assistance-cover-letter/letter',
        icon: '',
        roles: ['assistance_admin', 'assistance_salesman', 'assistance_chubb'],
      },
      providers: {
        title: 'Providers',
        url: '/admin/assistance/providers',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_providers.svg',
        roles: [
          'product supervisor',
          'networkleader',
          'assistance_admin',
          'assistance_bill_finances',
        ],
      },
      provider_priorities: {
        title: 'Provider Priorities',
        url: '/admin/assistance/providers/priorities',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/prioridades-proveedor.svg',
        roles: [
          'assistance_admin',
          'product supervisor',
          'networkleader',
        ],
      },
      holidays_management: {
        title: 'Holidays Management',
        url: '/admin/holidays/management',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/gestion-feriados.svg',
        roles: [
          'assistance_admin',
          'product supervisor',
          'networkleader',
        ],
      },
      dashboard_provider: {
        title: 'Dashboard provider',
        url: '/admin/provider/dashboard',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/catalogs.svg',
        roles: ['assistance_provider', 'admin']
      },
      provider_monitoring: {
        title: 'Provider Monitoring',
        url: '/admin/provider/monitoring',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/catalogs.svg',
        roles: ['networkleader', 'assistance_dispatcher', 'admin']
      },
      import_file: {
        title: 'Imports',
        url: '/admin/assistance/import-files',
        icon: 'fa fa-fw fa-download',
        roles: ['assistance_admin'],
      },
      reports: {
        title: 'Reports',
        url: '/admin/assistance/reports',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_reports.svg',
        roles: [
          'product supervisor',
          'supervisor',
          'quality',
          'assistance_admin',
          'assistance_salecapture_supervisor',
          'assistance_salescapture_cemex_supervisor',
          'assistance_salescapture_mr_barber_supervisor',
          'assistance_salescapture_impressa_repuestos_supervisor',
          'assistance_salescapture_credix_supervisor',
          'assistance_salescapture_coopenae_supervisor',
          'assistance_salescapture_trt_supervisor',
          'assistance_salescapture_suzuki_supervisor',
          'assistance_salescapture_instacredit_supervisor',
          'assistance_salescapture_promerica_supervisor',
          // 'assistance_provider',
          'networkleader',
          'assistance_bill_finances',
          'sds_buca_asesor',
          'medical_supervisor',
          'medical_admin'
        ],
      },
      reports_attachment: {
        title: 'Reports',
        url: '/admin/assistance/reportsattachment',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_reports.svg',
        roles: [
          'product supervisor',
          'supervisor',
          'quality',
          'assistance_admin',
          'assistance_salecapture_supervisor',
          'assistance_salescapture_cemex_supervisor',
          'assistance_salescapture_mr_barber_supervisor',
          'assistance_salescapture_impressa_repuestos_supervisor',
          'assistance_salescapture_credix_supervisor',
          'assistance_salescapture_coopenae_supervisor',
          'assistance_salescapture_trt_supervisor',
          'assistance_salescapture_suzuki_supervisor',
          'assistance_salescapture_instacredit_supervisor',
          'assistance_salescapture_promerica_supervisor',
          'assistance_provider',
          'networkleader',
          'assistance_bill_finances',
          'sds_buca_asesor',
          'medical_supervisor',
          'medical_admin'
        ],
      },
      reports_finances: {
        title: 'Reports Finances',
        url: '/admin/assistance/reportsfinances',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_reports.svg',
        roles: [
          'assistance_admin',
          'networkleader',
          'assistance_bill_finances',
        ],
      },
      reports_metabase: {
        title: 'Metabase Report',
        url: '/admin/assistance/metabase-dashboard',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_reports.svg',
        roles: [
          'assistance_admin',
          'metabase_report',
        ],
      },      
      reports_sinister_claims: {
        title: 'Reports Sinister Claims',
        url: '/admin/assistance/reports-sinister-claims',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_reports.svg',
        roles: [
          'assistance_admin', // AGREGAR ROLES AQUÍ
        ]
      },
      assistance_provider: {
        title: 'Billing',
        url: '/admin/assistance-providers/billing/0/0', //como cambie la ruta para indicar que tab esta activo, le mando 0 por defecto y id de proveedor 0
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_bill.svg',
        roles: ['assistance_provider', 'assistance_bill_finances', 'networkleader', 'sds_dentist'],
      },
      assistance_provider_bill: {
        title: 'Bills Approvement',
        url: '/admin/assistance-providers/bills',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/aprobar_factura.svg',
        roles: ['assistance_bill_finances', 'networkleader', 'sds_buca_asesor'],
      },
      assistance_provider_bill_claimed_inbox: {
        title: 'Bills claimed',
        url: '/admin/assistance-providers/bills/claimed',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_claims.svg',
        roles: ['assistance_bill_finances', 'networkleader', 'sds_buca_asesor'],
      },
      operation_sac: {
        title: 'Operacion sac',
        url: '/admin/assistance/operation_sac',
        icon: 'fa fa-exchange',
        roles: ['assistance_bill_finances', 'networkleader'],
      },
      teledoctor: {
        title: 'Teledoctor',
        url: '/admin/teledoctor',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/teledoctor.svg',
        roles: ['supervisor', 'assistance_admin'],
      },
      assistance_case_link: {
        title: 'Assistance Case',
        url: '/admin/assistance-case-link',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/chat-asistencas.svg',
        roles: ['supervisor', 'assistance_dispatcher', 'assistance_dispatcher_vial', 'assistance_dispatcher_vip'],
      },
      assistanceChubb: {
        title: 'Chubb Assistance',
        url: '/admin/assistance-chubb',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/catalogs.svg',
        roles: ['assistance_admin', 'assistance_chubb']
      },
      payment_requirement: {
        title: 'Payment Requirements',
        url: '/admin/assistance/sales/payments',
        img: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/requerimientos_pago.svg',
        roles: ['assistance_admin'],
        img_hover: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/requerimientos_pago_over.svg'
      },
      currency_exchange: {
        title: 'Currency exchange',
        url: '/admin/currency-exchange',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_bill.svg',
        img: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/cambio_divisas.svg',
        roles: ['assistance_admin'],
        img_hover: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/cambio_divisas_over.svg'
      },
      import_files: {
        title: 'Import File',
        url: '/admin/assistance/import-files',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/importar_archivo.svg',
        img: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/importar_archivo.svg',
        roles: ['assistance_admin'],
        img_hover: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/importar_archivo_over.svg'
      },
      temporalTransactions: {
        title: 'Temporal transactions',
        url: '/admin/temporal-transactions',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/transacciones_temporales.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/transacciones_temporales_over.svg",
        roles: ['admin', 'assistance_admin', 'assistance_salesman']
      },

      ICD10: {
        title: 'ICD10',
        url: '/admin/medical/icd-10',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/icd10/ICD10.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/icd10/ICD10_over.svg",
        roles: ['medical_admin', 'medical_operator', 'medical_supervisor', 'medical_doctor']
      },

      CPT: {
        title: 'CPT',
        url: '/admin/medical/cpts',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/cpt/CPT.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/cpt/CPT_over.svg",
        roles: ['medical_admin', 'medical_operator', 'medical_supervisor', 'medical_doctor']
      },

      CLASES: {
        title: 'Clases',
        url: '/admin/medical/cpts',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/claims.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/claims_hover.svg",
        roles: ['medical_admin', 'medical_operator', 'medical_supervisor', 'medical_doctor']
      },

      ESPECIALIDADES: {
        title: 'Especialidades',
        url: '/admin/medical/specialties',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/especialidades/especialidades.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/especialidades/especialidades_over.svg",
        roles: ['medical_admin', 'medical_operator', 'medical_supervisor', 'medical_doctor']
      },

      SUBESPECIALIDADES: {
        title: 'Subespecialidades',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/subespecialidades/sub.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/subespecialidades/sub_over.svg",
        url: '/admin/medical/subspecialties',

        roles: ['medical_admin', 'medical_operator', 'medical_supervisor', 'medical_doctor']
      },

      BACKGROUNDS: {
        title: 'Backgrounds',
        url: '/admin/medical/cpts',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/background/background.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/background/background_over.svg",
        roles: ['medical_admin', 'medical_operator', 'medical_supervisor', 'medical_doctor']
      },

      SINTOMAS: {
        title: 'Sintomas',
        url: '/admin/medical/symptoms',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/sintomas/sintomas.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/sintomas/sintomas_over.svg",
        roles: ['medical_admin', 'medical_operator', 'medical_supervisor', 'medical_doctor']
      },

      TIEMPOS: {
        title: 'Tiempos de Espera',
        url: '/admin/medical/wait-times',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/tiempos/tiempos.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/tiempos/tiempos_over.svg",
        roles: ['medical_admin', 'medical_operator', 'medical_supervisor', 'medical_doctor']
      },

      EXCLUSIONES: {
        title: 'Exclusiones',
        url: '/admin/medical/cpts',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/exclusiones/exclusiones.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/exclusiones/exclusiones_over.svg",
        roles: ['medical_admin', 'medical_operator', 'medical_supervisor', 'medical_doctor']
      },

      PREEXISTENCIAS: {
        title: 'Preexistencias',
        url: '/admin/medical/cpts',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/claims.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/claims_hover.svg",
        roles: ['medical_admin', 'medical_operator', 'medical_supervisor', 'medical_doctor']
      },
      ALERT: {
        title: 'Hallazgos',
        url: '/admin/all-alerts',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/notificacion_over.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/notificacion.svg",
        roles: ['quality', 'risk_officer', 'assistance_admin', 'supervisor']
      },
      MY_ALERTS: {
        title: 'Mis Hallazgos',
        url: '/admin/my_alerts',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/notificacion_over.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/notificacion.svg",
        roles: ['user_owner_quality_breach', 'assistance_admin', 'supervisor', 'operator', 'assistance_dispatcher', 'assistance_dispatcher_medical', 'assistance_dispatcher_vial', 'assistance_dispatcher_vip', 'assistance_operator_vip', 'assistance_salesman', 'quality', 'risk_officer', 'assistance_bill_finances', 'networkleader']
      },






      SATISFACTION_SURVERVEY_LIST: {
        title: 'Encuestas de satisfacción',
        url: '/admin/survey_list',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/notificacion_over.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/notificacion.svg",
        roles: ['assistance_admin', 'supervisor', 'operator', 'assistance_dispatcher', 'assistance_dispatcher_medical', 'assistance_dispatcher_vial', 'assistance_dispatcher_vip', 'assistance_operator_vip', 'assistance_salesman', 'quality', 'risk_officer', 'assistance_bill_finances', 'networkleader']
      },

      PAUTAS_LIST: {
        title: 'Pautas',
        url: '/admin/pauta_list',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/notificacion_over.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/notificacion.svg",
        roles: ['assistance_admin', 'supervisor', 'operator', 'assistance_dispatcher', 'assistance_dispatcher_medical', 'assistance_dispatcher_vial', 'assistance_dispatcher_vip', 'assistance_operator_vip', 'assistance_salesman', 'quality', 'risk_officer', 'assistance_bill_finances', 'networkleader']
      },


      EXTERNAL_ALERTS: {
        title: 'Crear Hallazgo',
        url: '/admin/external/quality-breach',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/create_case.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/create_case_hover.svg",
        roles: ['assistance_admin', 'supervisor', 'operator', 'assistance_dispatcher', 'assistance_dispatcher_medical', 'assistance_dispatcher_vial', 'assistance_dispatcher_vip', 'assistance_operator_vip', 'assistance_salesman', 'quality', 'risk_officer', 'assistance_bill_finances', 'networkleader']
      },

      letter_templates: {
        title: 'Plantillas de cartas',
        url: '/admin/assistance/letters',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/letter_template.svg',
        roles: [
          'assistance_admin',
        ],
      },
    };


    this.medical = new Nav();
    this.medical.title = 'Medical';
    this.medical.roles = ['medical_admin', 'medical_operator', 'medical_supervisor', 'medical_doctor'];
    this.medical.options = {
      sets: {
        title: 'Tipo de Proveedor Medico',
        url: '/admin/medical/sets',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/claims.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/claims_hover.svg",
        roles: ['medical_admin', 'teledoctor_admin']
      },
      backgrounds: {
        title: 'Medical History',
        url: '/admin/medical/backgrounds',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/background/background.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/background/background_over.svg",
        roles: ['medical_admin', 'teledoctor_admin']
      },
      exclusions: {
        title: 'Exclusions',
        url: '/admin/medical/exclusions',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/claims.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/claims_hover.svg",
        roles: ['medical_admin', 'teledoctor_admin']
      },

      medical_sales: {
        title: 'Medical Sales',
        url: '/admin/medical/sales',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/default/Medicas-ventas.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/hover/Medicas-ventas-HOVER%201.svg",
        icon: 'fa fa-bar-chart',
        roles: ['medical_admin', 'medical_analyst_supervisor'],
      },
      payment_requirement: {
        title: 'Medical Payment Requirements',
        url: '/admin/medical/sales/payments',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/default/Medicas-requerimientos-pago.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/hover/Medicas-requerimientos-pago-HOVER%201.svg",
        roles: ['medical_admin', 'supervisor']
      },

    };

    //Members
    this.members = new Nav();
    this.members.title = 'Miembros Activos';
    this.members.roles = ['assistance_admin'];
    this.members.options = {
      updateinfo: {
        title: 'Actualizar Informacion',
        url: '/admin/members/update',
        icon: 'fa fa-fw fa-file-text-o',
        roles: ['assistance_admin'],
      },
    };

    //Dental
    this.dental = new Nav();
    this.dental.title = 'Worksite';
    this.dental.roles = ['admin'];
    this.dental.options = {
      members: {
        title: 'Members',
        url: '/admin',
        icon: 'fa fa-fw fa-user-circle',
        roles: ['admin'],
        disabled: true,
      },
      companies: {
        title: 'Companies',
        url: '/admin',
        icon: 'fa fa-fw fa-building',
        roles: ['admin'],
        disabled: true,
      },
      measures: {
        title: 'Measures',
        url: '/admin',
        icon: 'fa fa-fw fa-ruler',
        roles: ['admin'],
        disabled: true,
      },
    };


    this.teledoctor = new Nav();
    this.teledoctor.title = 'Teledoctor';
    this.teledoctor.roles = [
      'teledoctor_admin', 'teledoctor_operator',
      'teledoctor_quality', 'teledoctor',
      'assistance_teledoctor_sale', 'supervisor', 'teledoctor_psicologic', 'teledoctor_odontologic'
    ];
    this.teledoctor.options = {
      consultations: {
        title: 'Consultations',
        url: '/admin/teledoctor/consultations',
        img: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/consultas_medicas.svg',
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/consultas_medicas_over.svg",
        roles: [
          'teledoctor_admin', 'teledoctor_operator',
          'teledoctor_quality', 'teledoctor', 'medico_bac_salud', 'teledoctor_observer',
          'teledoctor_doctor'
        ]
      },
      psicoconsultations: {
        title: 'Psicological Consultations',
        url: '/admin/teledoctor/psico-consultations',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/consultas_psicologicas.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/consultas_psicologicas_over.svg",
        roles: ['admin',
          'teledoctor_psicologic', 'teledoctor_admin', 'teledoctor_operator',
          'teledoctor_quality', 'medico_bac_salud', 'teledoctor_observer',
          'teledoctor_doctor'
        ]
      },
      odontoconsultations: {
        title: 'Odontological Consultations',
        url: '/admin/teledoctor/odonto-consultations',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/consultas_odonto.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/consultas_odonto_over.svg",
        roles: ['admin',
          'teledoctor_odontologic', 'teledoctor_admin', 'teledoctor_operator',
          'teledoctor_quality', 'medico_bac_salud', 'teledoctor_observer',
          'teledoctor_doctor'
        ]
      },

      doctorstatus: {
        title: 'Doctors Status',
        url: '/admin/teledoctor/doctorsavailable',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/estatus_doctores.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/estatus_doctores_over.svg",
        roles: ['teledoctor_admin']
      },
      teledoctorRealtime: {
        title: 'Actividad Teledoctor',
        url: '/admin/teledoctor/realtime',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/teledoctor_rtd.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/teledoctor_rtd_over.svg",
        roles: ['teledoctor_admin']
      },
      teledoctorActivityLog: {
        title: 'Teledoctor Log',
        url: '/admin/teledoctor/activitylog',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/teledoctor_log.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/teledoctor_log_over.svg",
        roles: ['teledoctor_admin']
      },
      calllog: {
        title: 'Call Log',
        url: '/admin/teledoctor/calllog',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/call_log.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/call_log_over.svg",
        roles: ['teledoctor_admin', 'teledoctor_operator', 'teledoctor_quality', 'assistance_dispatcher', 'assistance_dispatcher_medical', 'supervisor', 'teledoctor_doctor']
      },
      attemptCall: {
        title: 'Attempt Call',
        url: '/admin/teledoctor/track-attempts',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/default/TD-intento-llamadas.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/hover/TD-intento-llamadas-HOVER%201.svg",
        roles: ['teledoctor_admin', 'teledoctor_operator', 'teledoctor_quality', 'assistance_dispatcher', 'assistance_dispatcher_medical', 'supervisor', 'teledoctor_doctor']
      },
      faq: {
        title: 'Teledoctor FAQ',
        url: '/admin/teledoctor/faq',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/FAQ-normal.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/FAQ-hover.svg",
        roles: ['teledoctor_admin', 'teledoctor_operator', 'teledoctor_quality', 'assistance_dispatcher', 'assistance_dispatcher_medical', 'supervisor', 'teledoctor_doctor']
      },
    };

    //Other
    this.other = new Nav();
    this.other.title = 'Other';
    this.other.roles = [
      'assistance_admin',
      'insurance_admin',
      'medical_admin',
      'insurance_operator',
      'product supervisor',
      'assistance_chubb',
      'supervisor',
    ];
    this.other.options = {
      countries: {
        title: 'Countries',
        url: '/admin/countries',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_countries.svg',
        roles: [
          'assistance_admin',
          'insurance_admin',
          'medical_admin',
          'product supervisor',
        ],
      },
      countries_service: {
        title: 'Price service per country',
        url: '/admin/country-service',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_countries.svg',
        roles: [
          'assistance_admin',
          'insurance_admin',
          'medical_admin',
          'product supervisor',
        ],
      },
      users: {
        title: 'Users',
        url: '/admin/users',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_user.svg',
        roles: ['assistance_admin',
          'insurance_admin',
          'insurance_operator',
          'admin_providers_app',
          'admin_users',
          'admin_users_network',
          'admin_users_cabin_sac',
          'admin_users_ajustadores'],
      },
      cancellationReason: {
        title: 'CancellationReason',
        url: '/admin/cancellationreason',
        icon: 'fa fa-fw fa-edit',
        roles: ['assistance_admin', 'insurance_admin', 'medical_admin'],
      },
      emailValidation: {
        title: 'Email Validation',
        url: '/admin/email-validation',
        icon: 'far fa-envelope',
        roles: ['assistance_admin', 'assistance_chubb'],
      },
      management_map: {
        title: 'Mapa de Gestión',
        url: '/admin/management-map',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/gestion-mapa.svg',
        roles: [
          'assistance_admin',
          'product supervisor',
          'networkleader',
        ],
      },
      teledoctor: {
        title: 'Teledoctor',
        url: '/admin/teledoctor',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/teledoctor.svg',
        roles: ['admin', 'teledoctor_doctor'],
      },
      assistance_case_link: {
        title: 'Assistance Case Chat',
        url: '/admin/assistance-case-link',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/chat-asistencas.svg',
        roles: ['supervisor', 'assistance_dispatcher', 'assistance_dispatcher_vial', 'assistance_dispatcher_vip', 'admin'],
      },
      rss_message: {
        title: "RSS",
        url: "/admin/rss",
        icon: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/catalogs.svg",
        roles: ["admin"]
      },
      ucontact_did: {
        title: "Ucontact DID registers",
        url: "/admin/ucontact/did",
        icon: "fa fa-file-text-o",
        roles: ["admin"]
      },
      teledoctor2: {
        title: 'Teledoctor',
        url: '/admin/typologies',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/teledoctor.svg',
        roles: ['admin'],
      },
      whatsapp_templates: {
        title: 'WhatsApp Templates',
        url: '/admin/whatsapp-templates',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/02-meta-plantilla.svg',
        img: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/02-meta-plantilla.svg',
        img_hover: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/02-meta-plantilla-HOVER.svg',
        roles: ['admin', 'whatsapp_templates'],
      },
    };

    this.buca = new Nav();
    this.buca.title = 'BUCA';
    this.buca.roles = [
      'sds_dentist',
      'sds_buca_asesor',
      'sds_buca_analyst'
    ];
    this.buca.options = {
      pendings: {
        title: 'Pending Appointments',
        url: '/admin/buca-pending-appointments',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/cases2.svg',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/default/BUCA-citas-pendientes.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/hover/BUCA-citas-pendientes-HOVER%201.svg",
        roles: ['sds_dentist'],
      },
      follow_up_dentist: {
        title: 'Follow Up Patients',
        url: 'admin/buca-follow-up',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_cases.svg',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/default/BUCA-seguimiento-pacientes.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/hover/BUCA-seguimiento-pacientes-HOVER%201.svg",
        roles: ['sds_dentist'],
      },
      follow_up_cop: {
        title: 'Follow Up',
        url: 'admin/buca-follow-up',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_cases.svg',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/default/BUCA-seguimiento-casos.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/hover/BUCA-seguimiento-casos-HOVER%201.svg",
        roles: ['sds_buca_asesor', 'sds_buca_analyst'],
      },
      follow_up_unassigned: {
        title: 'Follow Up Unassigned',
        url: 'admin/buca-follow-up-unassigned',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_cases.svg',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/default/BUCA-seguimiento-casos-SIN-asignar.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/hover/BUCA-seguimiento-casos-SIN-asignar-HOVER%201.svg",
        roles: ['sds_buca_asesor', 'sds_buca_analyst'],
      },
      my_history: {
        title: 'My History',
        url: 'admin/buca-patient-history',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/cases2.svg',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/default/BUCA-mi-historial.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/hover/BUCA-mi-historial-HOVER%201.svg",
        roles: ['sds_dentist'],
      },
      search_engine: {
        title: 'Search Engine',
        url: 'admin/buca-search-engine',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/cases2.svg',
        roles: ['sds_buca_asesor', 'sds_buca_analyst'],
      },
      reports: {
        title: 'Buca Reports',
        url: '/admin/buca-reports',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_reports.svg',
        roles: [
          'assistance_admin',
          'assistance_bill_finances',
          'networkleader',
          'sds_buca_asesor',
          'admin'
        ],
      },

    }
    this.sds = new Nav();
    this.sds.title = 'SDS';
    this.sds.roles = [
      'sds_platformer',
      'sds_cop',
      'sds_ruling_doctor',
      'sds_call_center',
      'sds_admin',
      'sds_cop_sponsor',
      'sds_admin_sponsor',
      'sds_provider',
      'sds_technical_service',
      'sinister_client',
      'sds_guest',
      'sds_officer',
      'sds_insurance_broker',
      'sds_viewer',
      'sds_medical_analyst'
    ];
    this.sds.options = {
      dashboard: {
        title: 'SDS Dashboard',
        url: '/admin/sds/dashboard',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/cases2.svg',
        roles: ['sds_platformer', 'sds_admin'],
      },
      searchPolicy: {
        title: this.iam.hasThisRole('sinister_client') ? 'Pólizas' : 'Crear Nuevo Reclamo',
        url: 'admin/sds/search-policy',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_cases.svg',
        roles: ['sds_platformer',
          'sds_admin',
          'sinister_client'
        ],
      },
      myPendingProcedures: {
        title: this.iam.hasThisRole('sinister_client') ? 'Gestiones' : 'Mis Trámites',
        url: 'admin/sds/my-pendings',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_cases.svg',
        roles: ['sds_platformer',
          'sds_cop',
          'sds_ruling_doctor',
          'sds_call_center',
          'sds_cop_sponsor',
          'sds_provider',
          'sds_technical_service',
          'sinister_client',
          'sds_officer',
          'sds_medical_analyst'
        ],
      },
      sdsSearchEngine: {
        title: 'Todos los Trámites',
        url: 'admin/sds-search-engine',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/cases2.svg',
        roles: ['sds_platformer',
          'sds_cop',
          'sds_ruling_doctor',
          'sds_call_center',
          'sds_admin',
          'sds_cop_sponsor',
          'sds_admin_sponsor',
          'sds_provider',
          'sds_technical_service',
          'sds_guest',
          'sds_officer',
          'sds_insurance_broker',
          'sds_viewer',
          'sds_medical_analyst'
        ],
      },
      sinisterGuide: {
        title: 'Envío de Guía',
        url: '/admin/sds/guide',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/cases2.svg',
        roles: [
          'sds_platformer',
          'sds_cop',
          'sds_ruling_doctor',
          'sds_call_center',
          'sds_admin'],
      },
      cancelProcedure: {
        title: 'Cambiar Estado de Siniestro',
        url: '/admin/sds/cancel-procedure',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/cases2.svg',
        roles: ['sds_cop',
          'sds_admin'],
      },
      compensatedClaims: {
        title: 'Pagos Compensados',
        url: '/admin/sds/compensated-claims',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/cases2.svg',
        roles: ['sds_cop',
          'sds_admin'],
      },
      tooltipManager: {
        title: 'Editar Tooltips',
        url: '/admin/sds/tooltip-manager',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/cases2.svg',
        roles: ['sds_cop',
          'sds_admin'],
      },
      complementaryCases: {
        title: 'Sds Complementary Cases',
        url: 'admin/sds/sds-complementary-cases',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/cases2.svg',
        roles: [
          // 'sds_platformer',
          'sds_admin'],
      }
    }

    this.generalConfigurations = new Nav();
    this.generalConfigurations.title = 'General Configurations';
    this.generalConfigurations.roles = ['admin', 'assistance_admin', 'supervisor', 'admin_collectors', 'medical_admin', 'medical_supervisor', 'teamleader', 'insurance_admin', 'admin_qa'];
    this.generalConfigurations.options = {
      general_config: {
        title: 'General Configurations',
        url: 'admin/general-configurations',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/catalogs.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/catalogs_hover.svg",
        roles: ['admin', 'assistance_admin', 'supervisor', 'admin_collectors', 'medical_admin', 'medical_supervisor', 'teamleader', 'insurance_admin', 'admin_qa'],
      },
      pauses_config: {
        title: 'Pauses Configuration',
        url: 'admin/general-configurations/user-pauses',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/catalogs.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/catalogs_hover.svg",
        roles: ['admin', 'assistance_admin', 'supervisor'],
      },
      collectors: {
        title: 'Collectors',
        url: '/admin/collectors',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/default/collectors.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/hover/collectors-HOVER%201.svg",
        roles: ['admin', 'admin_collectors']
      },
      typologies: {
        title: 'Catalog of typologies',
        url: '/admin/typologies',
        img: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/cars.svg',
        img_hover: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/cars.svg',
        roles: ['admin'],
      },
      medical_expenses: {
        title: 'Health Services Config',
        url: '/admin/medical/managment',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/gastosmedicos/config2.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/gastosmedicos/config1.svg",
        roles: ['medical_admin', 'medical_supervisor']
      },
      assign_user_supervisor: {
        title: 'Assign User to Supervisor',
        url: '/admin/assign-user-management',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/hover/asignar-supervisor-HOVER.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/APOLO/assets/images/management_v2/default/asignar-supervisor.svg",
        roles: ['admin', 'assistance_admin', 'supervisor', 'teamleader']
      },
      qa_configuration: {
        title: 'Configuraciones QA',
        url: '/admin/qa_configuration',
        img: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/catalogs.svg",
        img_hover: "https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/catalogs_hover.svg",
        roles: ['admin_qa']
      },
      questions: {
        title: 'Questions',
        url: '/admin/questions',
        img: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_quality_questions.svg',
        img_hover: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/icon_quality_questions.svg',
        roles: ['insurance_admin'],
      },
      cars: {
        title: 'Cars',
        url: '/admin/cars/brands',
        icon: 'fa fa-fw fa-car',
        roles: ['assistance_admin'],
      },
      car_brand: {
        title: 'Cars',
        url: '/admin/cars/brands',
        img: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/cars.svg',
        img_hover: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/cars.svg',
        roles: ['assistance_admin']
      },
      signatures: {
        title: 'Email Signature',
        url: '/admin/mail_signature',
        img: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/firma.svg',
        img_hover: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/firma.svg',
        roles: ['admin'],
      },
    }
  }
}
